<div class="container-fluid footer-bg py-4">
    <footer class="d-flex flex-wrap justify-content-between align-items-center">
        <div class="col-12 d-flex justify-content-center align-items-center mb-3">
            <ul class="nav list-unstyled d-flex flex-wrap justify-content-center gap-3 ">
                <li routerLink="contact-us"><a class="text-white" target="_blank">Contact Us</a></li>
                <li routerLink="news"><a class="text-white" target="_blank">News</a></li>
                <li routerLink="privacyPolicy"><a class="text-white" target="_blank">Privacy Policy</a></li>
                <li routerLink="about"><a class="text-white"  target="_blank">About</a></li>

                <li routerLink="fairplay"><a class="text-white" target="_blank">Fair Play</a></li>
                <li routerLink="useragreement"><a class="text-white" target="_blank">User Agreement</a></li>
                <li> <span class="mb-3 mb-md-0 text-white">Chessx.ai © 2024</span></li>
            </ul>
        </div>

        <div class="col-12 justify-content-center align-items-center d-flex mb-3">
            <ul class="nav px-2 list-unstyled">
                <li class="ms-3"><a class="text-white" href="#"><i class="fa-brands fa-x-twitter"></i></a></li>
                <li class="ms-3"><a class="text-white" href="#"><i class="fa-brands fa-instagram"></i></a></li>
                <li class="ms-3"><a class="text-white" href="#"><i class="fa-brands fa-facebook"></i></a></li>
            </ul>
        </div>

    </footer>
</div>